import { BillingBlock } from 'types';

export const getActiveBillingBlocks = (billingBlocks: BillingBlock[] | undefined): BillingBlock[] => {
  if (!billingBlocks) return [];

  const now = new Date();
  return billingBlocks.filter((block) => {
    if (!block.expiresAt) return true;
    return new Date(block.expiresAt) > now;
  });
};
